import { useTranslation } from "react-i18next";
import { useWindowSize } from "@uidotdev/usehooks";
import { Button } from "@mui/material";
import team from "../../assets/img/company/team.png";
import { useNavigate } from "react-router-dom";

export const AboutUs = () => {
  const { t, i18n } = useTranslation();
  const { width } = useWindowSize();
  const isVietnamese = i18n.language === "vi";
  const navigate = useNavigate();

  const aboutParagraphs1 = [
    "aboutus.overtheyears",
    "aboutus.byfocus",
    "aboutus.established",
    "aboutus.itwasfound",
    "aboutus.ourjourney",
  ];

  const aboutParagraphs2 = [
    "aboutus.checkidfacielsensesystem",
    "aboutus.baseon",
    "aboutus.checkidfacielsensebio",
    "aboutus.althoughit",
    "aboutus.wheatheryou",
  ];

  return (
    <>
      {/* About us */}
      <div className="relative bg-cover bg-center h-[260px] md:h-[295px] smAndmd:h-[130px] exact768:h-[120px] exact1024:h-[150px] exact1920:h-[383px]">
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto pl-[10px]">
          <h1
            className={`inline-block h-[51px] text-5xl text-white font-extrabold ${
              isVietnamese ? "md:text-4xl" : ""
            } mt-[100px] smAndmd:mt-10 exact1024:mt-10`}
          >
            {t("aboutus.header")}
          </h1>
        </div>
      </div>

      <div className="pt-[30px] pb-[30px] md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto md:mt-[30px] mt-[30px] mb-[30px] px-4 exact1920:pt-[30px]">
        <div className="bg-white rounded-3xl border-[#EFF0F6] border-[1px] flex flex-col gap-8">
          {/* Left text block */}
          <div className="flex flex-row exact1024:flex-col mds:flex-col md:flex-col gap-5">
            {/* Text block + Heading */}
            <div className="flex-1 text-[#2B1C50] text-lg leading-7">
              {aboutParagraphs1.map((key) => (
                <p key={key} className="leading-7">
                  {t(key)}
                </p>
              ))}
            </div>

            {/* Right image */}
            <div className="flex-1 exact1024:mx-auto mds:mx-auto">
              <img
                src={team}
                alt="Team"
                className="rounded-xl object-cover w-128 h-128 "
              />
            </div>
          </div>

          {/* Left image + text block */}
          <div className="flex-1 flex flex-col gap-6 mt-10 exact1024:mt-0 mds:mt-0 md:mt-0">
            <h2
              className={`font-bold text-2xl text-[#151686] text-center ${
                isVietnamese ? "ml-[47%]" : "ml-[42%]"
              } exact1024:ml-0 mds:ml-0 md:ml-0`}
            >
              {t("aboutus.checkidfacialsensebiometric")}
            </h2>
            <div className="flex flex-row exact1024:flex-col-reverse mds:flex-col-reverse md:flex-col-reverse gap-15 exact1024:gap-5 mds:gap-5 md:gap-5 items-center justify-center w-full max-w-[1300px] mx-auto">
              {/* Bottom image */}
              <div className="my-auto">
                <img
                  src={team}
                  alt="Team"
                  className="rounded-xl object-cover w-128 h-128"
                />
              </div>

              {/* Text block + Heading */}
              <div className="flex-1 text-[#2B1C50] text-lg leading-7">
                {aboutParagraphs2.map((key) => (
                  <p key={key} className="leading-7">
                    {t(key)}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom solutions */}
      <div className="bg-[#151686]">
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto px-2 py-10 flex justify-between items-center text-white lg:px-6 exact1024:flex-col mds:flex-col md:flex-col">
          <div>
            <h1 className="text-[38px] leading-[56px] font-extrabold mb-6 exact1024:text-center mds:text-center md:text-center">
              {t("aboutus.customsolutions")}
            </h1>
            <p className="text-lg sm:text-center max-w-[500px] font-normal font-montserrat block ml-1">
              {t("aboutus.makesure")}
            </p>
          </div>
          <div className="exact1024:mt-5 mds:mt-5 md:mt-5 sm:w-full">
            <Button
              onClick={() => navigate("/contact-us")}
              variant="contained"
              sx={{
                padding: "10px 20px",
                bgcolor: "#F7941D",
                borderRadius: "30px",
                boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",
                width: width < 639 ? "100%" : "auto",
                fontSize: "16px",
                "&:hover": {
                  bgcolor: "rgb(242 170 83)",
                  boxShadow: "0px 12px 30px 0px rgba(24, 92, 255, 0.18)",
                },
                textTransform: "none",
              }}
            >
              {t("aboutus.contactus")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
